import { Autocomplete, TextField } from "@mui/material";
import type { SxProps } from "@mui/material";
import type { ReactNode } from "react";

interface FilterAutocompleteProps<T> {
  value: T;
  setFilterValue: (value: T | null) => void;
  getOptionLabel?: (option: T) => string;
  options: Array<T>;
  sx: SxProps;
  placeholder: string;
}

function FilterAutocomplete<T>({
  value,
  setFilterValue,
  getOptionLabel,
  options,
  sx,
  placeholder,
}: Readonly<FilterAutocompleteProps<T>>): ReactNode {
  return (
    <Autocomplete
      value={value === "" ? null : value}
      onChange={(_, newValue) => {
        setFilterValue(newValue);
      }}
      options={options}
      getOptionLabel={getOptionLabel}
      sx={sx}
      size="small"
      autoHighlight
      openOnFocus
      selectOnFocus
      renderInput={(params) => <TextField {...params} placeholder={placeholder} />}
    />
  );
}

export default FilterAutocomplete;
